import * as React from 'react';
import { useAccount, State } from '@grandvisionhq/auth';
import { useFeatureToggles } from '@grandvisionhq/state';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/graphql';
import '@grandvisionhq/payments';
import '@grandvisionhq/utils';
import '@swc/helpers';
import '@grandvisionhq/api-client';
import '../../../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '../../../mappers/errors-mapping.js';
import '../../../utils/get-customer-details-payload.js';
import '../../../models/cart/cart-state.js';
import '../../../models/checkout/checkout-step-error-type.js';
import '../../../models/checkout-settings.js';
import '../../../models/step-shipping/shipping-methods.js';
import '../../../models/shared.js';
import 'history';
import '../../../utils/has-cart-errors.js';
import '../../../context/CheckoutSettings/context.js';
import '../../../selectors.js';
import '@grandvisionhq/common';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../../operations/mutations/set-customer-details.js';
import '../../../operations/mutations/set-service-store.js';
import '../../../operations/mutations/set-shipping-method.js';
import '../../../operations/mutations/set-shipping-state.js';
import '../../../operations/mutations/set-store.js';
import '../../../operations/mutations/create-apple-pay-session.js';
import '../../../operations/mutations/recreate-ordered-checkout.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import { useFetchUserDetails } from '../../../hooks/user/use-fetch-user-details.js';
import { useAuthToken } from '../../../hooks/user/useAuthToken.js';

const useGetPreferredStore = ()=>{
    const { loadUserDetails , loading: isFetchingStoreId , userData  } = useFetchUserDetails();
    const { isMyAccountEnabled  } = useFeatureToggles();
    const authState = useAccount();
    const [, authTokenState] = useAuthToken();
    const authToken = authTokenState.data;
    const isLoggedIn = isMyAccountEnabled && authState === State.AuthState.LoggedIn && Boolean(authToken);
    const handleUserDetails = React.useCallback(()=>{
        authToken && loadUserDetails(authToken);
    }, [
        loadUserDetails,
        authToken
    ]);
    React.useEffect(()=>{
        if (isLoggedIn) {
            handleUserDetails();
        }
    // to avoid unneccesary re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoggedIn
    ]);
    return React.useMemo(()=>{
        return {
            globalStoreId: (userData === null || userData === void 0 ? void 0 : userData.globalStoreId) || undefined,
            isFetchingStoreId
        };
    }, [
        isFetchingStoreId,
        userData === null || userData === void 0 ? void 0 : userData.globalStoreId
    ]);
};

export { useGetPreferredStore };
//# sourceMappingURL=use-get-preferred-store.js.map
